import { 
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '../ui/dialog';
import { X } from 'lucide-react';

export const InvoiceImageModal = ({ invoice, isOpen, onClose }) => {
    if (!invoice) return null;
    
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-3xl">
                <DialogHeader>
                    <DialogTitle className="flex items-center justify-between">
                        {invoice.name}
                        <button 
                            onClick={onClose}
                            className="p-1 hover:bg-slate-100 rounded"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </DialogTitle>
                </DialogHeader>
                <div className="flex items-center justify-center p-4">
                    {invoice.image_data ? (
                        <img
                            src={`data:image/jpeg;base64,${invoice.image_data}`}
                            alt={invoice.name}
                            className="max-h-[70vh] object-contain rounded-lg"
                        />
                    ) : (
                        <p className="text-slate-500">No hay imagen disponible</p>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
};
